import { Moment } from 'moment';
import { TipoApropriacao } from './tipo-apropriacao.model';
import { TipoDispendio } from './tipo-dispendio.model';

export class DispendioEquipamentoSoftware {

  id: number;
  descricao: string;
  idProjeto: number;
  dispendioProprio: boolean;
  descricaoOutrosTipoApropriacao: string;
  valorDispendio: number;
  valorDepreciacao: number;
  dataAquisicao: Moment;
  dataInicioAluguel: Moment;
  dataFimAluguel: Moment;
  justificativa: string;
  tipoDispendio: TipoDispendio;
  tipoApropriacao: TipoApropriacao;
  dispendioImportado: boolean;
  checked?: boolean;

  constructor(init?: Partial<DispendioEquipamentoSoftware>) {
    Object.assign(this, init);
  }
}
